import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthCtx } from "../lib/auth-provider";
import { Spinner } from "./spinner";

export function AdminGuard({ children }: { children: ReactNode }) {
  const { user, claims, loading } = useAuthCtx();
  const location = useLocation();
  if (loading || (user && !claims)) return <Spinner />;
  // Back to the exact page after login: the link in the license email points
  // at one user's card, and landing on the list instead loses which one.
  if (!user) {
    const back = location.pathname + location.search + location.hash;
    return <Navigate to={`/login?return=${encodeURIComponent(back)}`} replace />;
  }
  if (!claims || (claims as { admin?: boolean }).admin !== true) {
    return <Navigate to="/home" replace />;
  }
  return <>{children}</>;
}
